<script setup>
import { currency } from '~/ui/vue/filters'

const props = defineProps({
  params: {
    type: Object,
    required: true
  }
})

const value = computed(() => {
  const guarantee = props.params.data?.acvValues?.guarantee
  const unitCost = props.params.data?.price?.unitCost?.amount

  if (!guarantee || !unitCost) return null
  return guarantee - unitCost
})

const formattedValue = computed(() => {
  if (value.value === null || value.value === undefined) return '-'
  return currency(value.value)
})

const textColorClass = computed(() => {
  if (value.value === null || value.value === undefined) return ''
  return value.value >= 0 ? 'text-success' : 'text-red'
})
</script>

<template>
  <span :class="textColorClass">
    {{ formattedValue }}
  </span>
</template>
